import {isLocalhost} from '../lib/isLocalOrDevEnvironment';

// On localhost the SPA (vite, :3030) and the API (:7272) are separate origins, so the API
// needs an absolute base. Everywhere else is single-origin and requests are root-relative:
// in production the API serves the built SPA, and over a Cloudflare dev tunnel vite proxies
// /api and /hubs through to the API (see vite.config.ts).
const baseUrl = isLocalhost ? 'https://localhost:7272' : '';

export default baseUrl;
